module.exports = __webpack_public_path__ + "images/partner5.07a0308d.svg";